import { observable, action } from 'mobx';

class ShippingUIState {
  @observable continueButtonIsEnabled = true;

  @observable continueButtonIsLoading = false;

  @observable addressSelectionIsEnabled = true;

  @observable isShippingMethodsMissing = false;

  @observable addressSelectionIsLoading = false;

  @observable shippingMethodSelectionIsLoading = false;

  @action
  public updateContinueButtonState(isEnabled: boolean): void {
    this.continueButtonIsEnabled = isEnabled;
  }

  @action
  public updateContinueLoadingButtonState(isLoading: boolean): void {
    this.continueButtonIsLoading = isLoading;
    this.continueButtonIsEnabled = !isLoading;
  }

  @action
  public updateAddressSelectionState(isEnabled: boolean): void {
    this.addressSelectionIsEnabled = isEnabled;
  }

  @action
  public updateisShippingMethodsMissing(isFailed: boolean): void {
    this.isShippingMethodsMissing = isFailed;
    if (isFailed) {
      this.continueButtonIsEnabled = false;
      this.continueButtonIsLoading = false;
      this.addressSelectionIsEnabled = false;
    }
  }

  @action
  public updateAddressSelectionLoadingState(isLoading: boolean): void {
    this.addressSelectionIsLoading = isLoading;
  }

  @action
  public updateShippingMethodLoadingState(isLoading: boolean): void {
    this.shippingMethodSelectionIsLoading = isLoading;
  }

  @action
  public restoreDefaults(): void {
    this.continueButtonIsEnabled = true;
    this.continueButtonIsLoading = false;
    this.addressSelectionIsEnabled = true;
    this.isShippingMethodsMissing = false;
    this.addressSelectionIsLoading = false;
    this.shippingMethodSelectionIsLoading = false;
  }
}

export default ShippingUIState;
